





































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { ACard } from "@canvas/componentlibrary";
import Table from "./PaymentCollectionTable.vue";
import { get } from "@/api";
import store from "../../store";
export default Vue.extend({
  name: "payments-collected",
  data() {
    return {
      isFilterPopupVisible: false,
      filters: {
        status: {
          open: false,
          approved: false,
          rejected: false,
        },
        paymentType: `${store.state.appModule.config?.cashRequestType},${store.state.appModule.config?.chequeTypeRequest}`, // "cmsscb", "cheque", or "cmsscb,cheque"
        searchPID: "",
      },
      constants: {
        paymentType: {
          cmsscb: store.state.appModule.config?.cashRequestType,
          cheque: store.state.appModule.config?.chequeTypeRequest,
          all: `${store.state.appModule.config?.cashRequestType},${store.state.appModule.config?.chequeTypeRequest}`,
        },
      },
      currentPage: 0,
      fetchSize: 10,
      totalCount: 0,
      tableData: [],
      appliedFilters: [],
      tableDataKey: 0,
      is_next_page_count: 10,
      is_next_page_start: 0,
      is_next: true,
    };
  },
  components: {
    Table,
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
      mobileAddonOption: "mobileAddonOption",
      config: "config",
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      breadcrumb: "breadcrumb",
    }),
    totalPages() {
      return Math.ceil((this as any).totalCount / (this as any).fetchSize);
    },
    filteredData() {
      const activeFilters = Object.keys((this as any).filters).filter(
        (key) => (this as any).filters[key]
      );
      return (this as any).tableData.filter((item: any) => {
        if (activeFilters.length === 0) return true;
        return activeFilters.some((filter) => item.status === filter);
      });
    },
  },

  methods: {
    ...mapActions("appModule", ["searchInventoryProducts"]),
    toggleFilterPopup() {
      (this as any).isFilterPopupVisible = !(this as any).isFilterPopupVisible;
    },
    handleFilterPopUpClose() {
      (this as any).isFilterPopupVisible = false;
    },
    async fetchData(pageType = "current") {
      try {
        (this as any).$store.commit("uiModule/showLoadingModal", null, { root: true });
        const queryParts = [];
        let tags = `tags:EC:${store.state.appModule.selectedEc?.name}`;
        if ((this as any).filters.searchPID?.trim()) {
          tags += `,PID:${(this as any).filters.searchPID.trim()}`;
        }
        queryParts.push(tags);

        let requestStatus = [];
        if ((this as any).filters.status.open) requestStatus.push("OPEN");
        if ((this as any).filters.status.approved) requestStatus.push("APPROVED");
        if ((this as any).filters.status.rejected) requestStatus.push("REJECTED");
        if (requestStatus.length) queryParts.push(`;status:${requestStatus.join(",")}`);

        let start;
        if (pageType === "next") {
          start = (this as any).is_next_page_start;
        } else if (pageType === "prev") {
          start = Math.max(
            0,
            (this as any).is_next_page_start - (this as any).is_next_page_count
          );
        } else {
          start = (this as any).currentPage * (this as any).fetchSize;
        }

        const query = queryParts.join("");

        const paginatedQuery = `${query};steps.name:${
          store.state.appModule.config?.ecCollectionManager
          },${store.state.appModule.config?.ecDepositManager
          },${store.state.appModule.config?.ecManager
          };include:comments;request_types:${(this as any).filters.paymentType}&start=${start}&count=${(this as any).fetchSize}`;

        const response: any = await get({
          endpoint: "core.workflow.api.v1.requests",
          query: paginatedQuery,
        });

        (this as any).tableData = response.items || [];
        (this as any).totalCount = response.total_count || 0;
        (this as any).filteredData = (this as any).tableData;
        (this as any).tableDataKey += 1;
        (this as any).is_next = response.is_next;
        (this as any).is_next_page_count = response.is_next_page_count;
        (this as any).is_next_page_start = response.is_next_page_start;
      } catch (error) {
        // TODO
        /** Handle this */
        /** Show message to user if it is required */
        // console.error("Error fetching data:", error);
      } finally {
        (this as any).$store.commit("uiModule/hideLoadingModal", null, { root: true });
      }
    },
    changePage(newPage: any) {
      const totalPages = Math.ceil(
        (this as any).totalCount / (this as any).fetchSize
      );

      if (newPage < 0 || newPage >= totalPages) return;

      (this as any).currentPage = newPage;
      const pageType =
        newPage > (this as any).currentPage
          ? "next"
          : newPage < (this as any).currentPage
          ? "prev"
          : "current";
      (this as any).fetchData(pageType);
    },
    async applyFilters() {
      (this as any).appliedFilters = [];
      const appliedFilters = (this as any).filters;
      if (Object.entries(appliedFilters.status).some(([key, value]) => value)) {
        (this as any).appliedFilters.push("Status");
      }
      if (appliedFilters.paymentType !== (this as any).constants.paymentType.all) {
        (this as any).appliedFilters.push("Payment Type");
      }
      (this as any).currentPage = 0;

      const filterParams = {
        filters: (this as any).appliedFilters,
        page: (this as any).currentPage,
        pageSize: (this as any).pageSize || 10,
      };

      await (this as any).fetchData(filterParams);

      (this as any).isFilterPopupVisible = false;
    },
    resetFilters() {
      if (!(this as any).appliedFilters?.length) return;
      (this as any).filters = {
        ...(this as any).filters,
        status: {
          open: false,
          approved: false,
          rejected: false,
        },
        paymentType: `${store.state.appModule.config?.cashRequestType},${store.state.appModule.config?.chequeTypeRequest}`,
      };
      (this as any).appliedFilters = [];
      (this as any).isFilterPopupVisible = false;
      (this as any).applyFilters();
    },
    resetPIDSearch() {
      if (!(this as any).filters.searchPID) return;
      (this as any).filters.searchPID = "";
      (this as any).applyFilters();
    },
  },
  watch: {
    selectedEc() {
      // Reload payment data when EC changes
      (this as any).currentPage = 0;
      (this as any).fetchData();
    },
  },
  async created() {
    await (this as any).fetchData();
  },
});
